(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets-einstant/assets/javascripts/shared/components/sort-games.js') >= 0) return;  svs.modules.push('/modules/tickets-einstant/assets/javascripts/shared/components/sort-games.js');
"use strict";

const _svs$ui$ReactDropdown = svs.ui.ReactDropdown,
  DropdownSelectItem = _svs$ui$ReactDropdown.DropdownSelectItem,
  DropdownItem = _svs$ui$ReactDropdown.DropdownItem,
  DropdownLabel = _svs$ui$ReactDropdown.DropdownLabel;
const Icon = svs.ui.ReactIcon;
const SortGames = _ref => {
  var _activeOption$label;
  let selected = _ref.selected,
    setSelected = _ref.setSelected,
    _ref$hideDefault = _ref.hideDefault,
    hideDefault = _ref$hideDefault === void 0 ? false : _ref$hideDefault,
    _ref$placeholderLabel = _ref.placeholderLabel,
    placeholderLabel = _ref$placeholderLabel === void 0 ? 'Sortera' : _ref$placeholderLabel;
  const _svs$eInstant$constan = svs.eInstant.constants,
    sortOptions = _svs$eInstant$constan.sortOptions,
    getSortOptionById = _svs$eInstant$constan.getSortOptionById;
  const filteredOptions = React.useMemo(() => hideDefault ? sortOptions.filter(opt => opt.id !== 'default') : sortOptions, [hideDefault, sortOptions]);
  const current = getSortOptionById(selected);
  const activeOption = hideDefault && (current === null || current === void 0 ? void 0 : current.id) === 'default' ? null : current;
  const buttonLabel = (_activeOption$label = activeOption === null || activeOption === void 0 ? void 0 : activeOption.label) !== null && _activeOption$label !== void 0 ? _activeOption$label : placeholderLabel;
  return React.createElement(DropdownSelectItem, {
    defaultText: buttonLabel,
    onSelect: setSelected,
    v2: true
  }, filteredOptions.map(option => React.createElement(DropdownItem, {
    "aria-selected": (activeOption === null || activeOption === void 0 ? void 0 : activeOption.id) === option.id,
    key: option.id,
    name: option.id,
    selected: (activeOption === null || activeOption === void 0 ? void 0 : activeOption.id) === option.id
  }, React.createElement(Icon, {
    className: option.iconClasses,
    icon: option.icon
  }), React.createElement(DropdownLabel, null, option.label))));
};
setGlobal('svs.eInstant.shared.components.SortGames', SortGames);

 })(window);